import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateClassroomForm from "../../forms/CreateOrUpdateClassroomForm";
import { ClassroomResponseDto } from "../../shared/dtos/classroom/ClassroomResponseDto";

interface UpdateClassroomModalProps {
  open: boolean;
  onClose: () => void;
  classroom: ClassroomResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateClassroomModal: React.FC<UpdateClassroomModalProps> = ({
  open,
  onClose,
  classroom,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${classroom.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateClassroomForm
      isEditing={true}
      classroom={classroom}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateClassroomModal;
